package com.shadowings.gero.data.lessons.chapter12

import com.shadowings.gero.domain.model.MultiPressContent
import com.shadowings.gero.domain.model.MultiPressPair
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.question_type_multipress

fun buildMultiPress(words: List<Word>, languageCode: String): MultiPressContent {
    require(words.size == 4) { "buildMultiPress richiede esattamente 4 parole, ricevute ${words.size}" }
    return MultiPressContent(
        pairs = words.map { MultiPressPair(hieroglyphs = it.gardiner, meaning = it.getMeaning(languageCode)) },
        prompt = Res.string.question_type_multipress
    )
}
